module.exports = __webpack_public_path__ + "img/gross-icon.8d6e5595.svg";